<template>
    <div
        class="section-cta bg-img"
        :style="{ backgroundImage: `url(${sectionBlock.img.url})` }"
    >
        <div class="container-xxl">
            <div class="row justify-content-center">
                <div class="col-matrix">
                    <div class="row">
                        <div class="col-12 col-lg-8 col-xl-7 col-xxl-6">
                            <h6 v-if="sectionBlock.sectionSubtitle !== ''" class="mb-4">{{sectionBlock.sectionSubtitle}}</h6>
                            <h3 v-if="sectionBlock.sectionTitle !== ''">{{sectionBlock.sectionTitle}}</h3>

                            <a v-if="sectionBlock.sectionLink !== null && sectionBlock.sectionLink.fr" :href="sectionBlock.sectionLink.fr" class="button mt-4">
                                {{sectionBlock.sectionLinkText}}
                            </a>
                            <a v-else-if="sectionBlock.sectionLink !== null" :href="sectionBlock.sectionLink" class="button mt-4">
                                {{sectionBlock.sectionLinkText}}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'sectionCta',
    components: {
        // AssetLoader
    },
    props: {
        sectionBlock: {
            type: Object,
            required: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
        shuffleArray(array) {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1))
                ;[array[i], array[j]] = [array[j], array[i]]
            }
            return array.slice(0, 3)
        },
    },
    // On loaded...
    mounted() {},
}
</script>
